/**
 * Generates a random alphanumeric ID of the specified length.
 * @param length The length of the alphanumeric ID to be generated.
 * @returns A random alphanumeric ID.
 */
const generateAlphaNumericId = (length: number): string => {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  const charactersLength = characters.length
  let result = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength)
    result += characters.charAt(randomIndex)
  }

  return result
}

export default generateAlphaNumericId
